import * as React from 'react';
import type { NodeAPIData } from 'types/catalog_types';
import type { MaskNodeStyleProp } from 'types/node_types';

type MaskNodeProps = {
  node: NodeAPIData;
  styles: MaskNodeStyleProp;
  onLoad: React.ReactEventHandler<HTMLImageElement>;
  renderedSVG: string | null;
};

function MaskNode({ node, styles, onLoad, renderedSVG = null }: MaskNodeProps) {
  return (
    <div
      className="mask_node"
      data-testid="mask-node"
      data-id={node.id}
      data-uid={node.uid}
      style={styles.node}
    >
      {!node.svg_id && node.node_image && (
        <img
          src={node.node_image}
          style={styles.maskImage}
          onLoad={onLoad}
          className="mask_image"
          alt=""
        />
      )}
      {renderedSVG && (
        <div style={styles.maskImage} dangerouslySetInnerHTML={{ __html: renderedSVG }} />
      )}
    </div>
  );
}

export default MaskNode;
